import * as React from "react";
import { Stack } from "@mui/material";

export function Breadcrumbs({ children }: { children: React.ReactNode }) {
	return (
		<Stack direction={"row"} spacing={1} whiteSpace={"pre"} alignItems={"center"}>
			{children}
		</Stack>
	);
}
